export default __webpack_public_path__ + "static/DINosaurKU-Book-49aed02cc27cd307d25163c43f3016ba.woff2";